import f from "../../../funcs";
import Events from "../../Events";
import RowsStorage from "../RowsStorage";


// TODO: удалить этот плагин, когда появится нормальный кэш


let OPERATION = RowsStorage.get("OPERATION");
let OPERATION_SEA = RowsStorage.get("OPERATION_SEA");
let OPERATION_TRAIN = RowsStorage.get("OPERATION_TRAIN");
let OPERATION_CUSTOMS = RowsStorage.get("OPERATION_CUSTOMS");
let OPERATION_FORWARD = RowsStorage.get("OPERATION_FORWARD");
let OPERATION_AUTO = RowsStorage.get("OPERATION_AUTO");
let OPERATION_REPACKING = RowsStorage.get("OPERATION_REPACKING");
let OPERATION_DOCUMENTATION = RowsStorage.get("OPERATION_DOCUMENTATION");
let OPERATION_OTHER = RowsStorage.get("OPERATION_OTHER");

let storageArr = [OPERATION, OPERATION_SEA, OPERATION_TRAIN, OPERATION_AUTO, OPERATION_CUSTOMS, OPERATION_FORWARD, OPERATION_REPACKING, OPERATION_DOCUMENTATION, OPERATION_OTHER];

let StupidFixFinDeleted = Events.extend("StupidFixFinDeleted", {

    init(storage) {
        let currentStorage = storage;

        let trash = currentStorage.trash;
        currentStorage.trash = function(id, callback) {
            let ids = [id];
            if ( f.isArray(id) ) {
                ids = id;
            }
            ids = ids.map(function(id) {
                return id + "";
            });

            storageArr.forEach(function(storage) {
                storage.collection.each(function(operationModel) {
                    let finOperationBuyId = operationModel.get("ID_FIN_OPERATION_BUY");
                    let finOperationSaleId = operationModel.get("ID_FIN_OPERATION_SALE");

                    if (
                        finOperationBuyId && ids.indexOf(finOperationBuyId) === -1
                    ) {
                        operationModel.set({
                            FIN_OPERATION_BUY_DELETED: 1
                        }, {
                            update: false
                        });
                        storage.sendEvent("__customRefreshInclude", operationModel);
                    }

                    if (
                        finOperationSaleId && ids.indexOf(finOperationSaleId) === -1
                    ) {
                        operationModel.set({
                            FIN_OPERATION_SALE_DELETED: 1
                        }, {
                            update: false
                        });
                        storage.sendEvent("__customRefreshInclude", operationModel);
                    }
                });
            });

            return trash.call(currentStorage, ids, callback);
        };
    }
});


export default StupidFixFinDeleted;
